const ModelProxy = {

    set: (object:any, key:any, value:any, proxy:any) => {

        // console.green("----->", key, value)

        if (Reflect.has(object, key)) {
            object[key] = value;
            object.updatedFields.add(key);
        } else {
            console.error("set: Field [{0}] doesnt exist".f(key));
        }
        return true;
    },

    get: (object:any, key:any, proxy:any) => {
        if (Reflect.has(object, key)) {
            return object[key]
        } else {
            // special case
            // A String value that is used in the creation of the default string description of an object. Called by the built-in method Object.prototype.toString.
            if (key === Symbol.toStringTag || ['@@toStringTag'].includes(key))
                return object.constructor.name;

            return undefined;
        }
    }
}

export default ModelProxy
